import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Bande from './Bande';
import {
  CATEGORIES,
  lireConsentement,
  ecrireConsentement,
  toutAccepter,
  toutRefuser,
  EVENEMENT,
} from './consentement';

export default function BandeauCookies() {
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState(false);
  const [choix, setChoix] = useState({ audience: false, tiers: false });

  useEffect(() => {
    setVisible(lireConsentement() === null);
    const surChangement = (e) => {
      if (e.detail === null) {
        setDetail(false);
        setChoix({ audience: false, tiers: false });
        setVisible(true);
      }
    };
    window.addEventListener(EVENEMENT, surChangement);
    return () => window.removeEventListener(EVENEMENT, surChangement);
  }, []);

  if (!visible) return null;

  const fermer = () => setVisible(false);
  const basculer = (id) => setChoix((c) => ({ ...c, [id]: !c[id] }));

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label="Gestion des cookies"
      className="fixed z-[60] inset-x-0 bottom-0 md:bottom-4 md:left-4 md:right-auto md:max-w-[440px]"
    >
      <div className="bg-nuit text-white shadow-haut md:rounded-[4px] overflow-hidden border-t-2 md:border-2 border-jaune max-h-[85vh] overflow-y-auto">
        <Bande hauteur={5} />
        <div className="p-5 sm:p-6 pb-[calc(1.25rem+env(safe-area-inset-bottom))] md:pb-6">
          <h2 className="font-display uppercase text-[20px] leading-tight">
            Cookies et <span className="mot-degrade">mesure d'audience</span>
          </h2>
          <p className="mt-2.5 text-[15px] text-white/75 leading-relaxed">
            Nous utilisons des cookies pour mesurer la fréquentation du site et pour afficher
            la carte de notre dépôt. Aucun cookie publicitaire, aucune revente de données.
            Vous décidez, et vous pouvez changer d'avis à tout moment.
          </p>

          {detail && (
            <div className="mt-4 space-y-2.5 border-t border-white/15 pt-4">
              {CATEGORIES.map((c) => {
                const actif = c.verrouille ? true : choix[c.id];
                return (
                  <div key={c.id} className="bg-white/5 rounded-[3px] p-3.5">
                    <label
                      htmlFor={`cat-${c.id}`}
                      className={`flex items-start gap-3 ${c.verrouille ? '' : 'cursor-pointer'}`}
                    >
                      <input
                        id={`cat-${c.id}`}
                        type="checkbox"
                        checked={actif}
                        disabled={c.verrouille}
                        onChange={() => basculer(c.id)}
                        className="mt-0.5 w-5 h-5 shrink-0 accent-[#F5B301] disabled:opacity-50"
                      />
                      <span>
                        <span className="block font-cond uppercase font-bold tracking-[0.05em] text-[15px]">
                          {c.titre}
                          {c.verrouille && (
                            <span className="ml-2 text-white/45 font-normal tracking-normal normal-case text-[13px]">
                              toujours actifs
                            </span>
                          )}
                        </span>
                        <span className="block mt-1 text-[13.5px] text-white/65 leading-snug">
                          {c.texte}
                        </span>
                      </span>
                    </label>
                  </div>
                );
              })}
            </div>
          )}

          <div className="mt-4 flex flex-col sm:flex-row gap-2.5">
            <button
              type="button"
              onClick={() => {
                toutAccepter();
                fermer();
              }}
              className="btn-jaune flex-1 !py-3 !text-[15px]"
            >
              Tout accepter
            </button>
            <button
              type="button"
              onClick={() => {
                toutRefuser();
                fermer();
              }}
              className="btn-contour flex-1 !py-3 !text-[15px]"
            >
              Tout refuser
            </button>
          </div>

          <div className="mt-2.5">
            {detail ? (
              <button
                type="button"
                onClick={() => {
                  ecrireConsentement(choix);
                  fermer();
                }}
                className="btn-contour w-full !py-3 !text-[15px] !border-white/20"
              >
                Enregistrer mes choix
              </button>
            ) : (
              <button
                type="button"
                onClick={() => setDetail(true)}
                className="w-full text-center font-cond uppercase tracking-[0.08em] text-[14px] text-white/70 hover:text-jaune transition-colors py-2"
              >
                Personnaliser
              </button>
            )}
          </div>

          <p className="mt-3 text-[13px] text-white/50 text-center">
            <Link to="/cookies" className="text-jaune underline underline-offset-2">
              Politique de cookies
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
